import { isNgServe } from '@core';

import { Environment } from './type';

export const environment: Environment = {
  name: 'MLSE - DEV',
  machineName: 'dev',
  production: true,
  serviceWorker: !isNgServe,
  debug: true,
  apiUrl: 'https://oongalee-exscuseme-srv-dev.r2.danavero.com',
  socketApi: 'wss://oongalee-exscuseme-srv-dev.r2.danavero.com',
  sentry: {
    dsn: '',
  },
  backgroundPlayer: null,
  backgroundAdPlayer: 'https://ad.apps.dwall.online',
  backgroundAdPlayerColor: null,
  update: {
    checkStrategy: 'every-minute',
    activateStrategy: 'restart-when-idle',
  },
  featureToggle: {
    idleClickGoTo: ['/main/home'],
    withTabBar: true,
    withCallWaiter: {
      main: false,
      secondary: false,
      tertiary: false,
    },
    withCallWaiterOnOffline: false,
    withInvoice: false,
    withServiceCentre: false,
    tabBarAutoHide: false,
    idleDelay: 30,
    ambientLight: {
      callWaiter: {
        main: null,
        secondary: null,
        tertiary: null,
      },
    },
  },
};
